<template>
    <div class="white-rounded-box mb-7 h-fit">
        <div class="mx-3 my-4">
            <p class="mb-2">Hours:</p>
            <a
                v-if="isOwnStorefront"
                class="flex justify-end -translate-y-6"
                title="Storefront"
                @click="toggleBusinessHours()"
            >
                <svg-vue
                    icon="pencil-solid"
                    title="storefront icon"
                    class="w-5 h-5 fill-black"
                />
            </a>
            <div>
                <div
                    v-if="editingHours"
                    class="flex flex-wrap gap-2 w-full justify-between"
                >
                    <div
                        class="dark:bg-white"
                        v-for="(day, key) in hoursEditData"
                        :key="key"
                    >
                        <div class="flex mx-auto">
                            <span class="min-w-[15px] max-w-[15px]">{{
                                day.name.charAt(0)
                            }}</span>
                            <div class="inline-flex flex-wrap items-center">
                                <TimePicker
                                    class="ml-1"
                                    @update-time="updateBusinessHours"
                                    :day="day.name"
                                    :times="day.start"
                                    :type="'start'"
                                    :clickable="day.closed"
                                    :storefront="true"
                                />
                                <TimePicker
                                    class="ml-1"
                                    @update-time="updateBusinessHours"
                                    :day="day.name"
                                    :times="day.end"
                                    :type="'end'"
                                    :clickable="day.closed"
                                    :storefront="true"
                                />
                                <span class="ml-1"
                                    >Closed
                                    <t-checkbox
                                        name="options"
                                        v-model="day.closed"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                    <button
                        :hidden="isSaveButtonDisabled"
                        type="button"
                        @click="submitHours"
                        class="flex mx-auto mt-2 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    >
                        Save
                    </button>
                </div>
                <div v-else>
                    <HourRow
                        v-for="(day, key) in hoursShowData"
                        :key="key"
                        :label="day.name"
                        :start="day.start"
                        :end="day.end"
                        :closed="day.closed"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TimePicker from "../../ControlPanel/partials/TimePicker.vue";
import { days } from "../../../constants/days";
import HourRow from "../../Utils/HourRow.vue";
export default {
    props: ["isOwnStorefront", "user"],
    data() {
        return {
            hoursShowData: {
                Monday: {
                    name: "Monday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Tuesday: {
                    name: "Tuesday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Wednesday: {
                    name: "Wednesday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Thursday: {
                    name: "Thursday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Friday: {
                    name: "Friday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Saturday: {
                    name: "Saturday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Sunday: {
                    name: "Sunday",
                    start: null,
                    end: null,
                    closed: true,
                },
            },
            hoursEditData: {},
            days: days,
            editingHours: false,
            isSaveButtonDisabled: true,
            businessHoursArray: [],
            hoursType: "business",
        };
    },
    components: {
        HourRow,
        TimePicker,
    },
    methods: {
        createArrayToEmit() {
            let resultArray = [];
            Object.keys(this.hoursEditData).forEach((key, index) => {
                if (!this.hoursEditData[key].closed) {
                    resultArray.push({
                        day_of_week: this.getISOWeekDayNumber(key),
                        start_time: this.hoursEditData[key].start,
                        end_time: this.hoursEditData[key].end,
                        usage: this.getScheduleItemUsage(),
                    });
                }
            });
            return resultArray;
        },
        getISOWeekDayNumber(day) {
            switch (day) {
                case "Monday":
                    return 1;
                    break;
                case "Tuesday":
                    return 2;
                    break;
                case "Wednesday":
                    return 3;
                    break;
                case "Thursday":
                    return 4;
                    break;
                case "Friday":
                    return 5;
                    break;
                case "Saturday":
                    return 6;
                    break;
                case "Sunday":
                    return 7;
                    break;
                default:
                    return null;
            }
        },
        getISOWeekDayName(day) {
            switch (day) {
                case 1:
                    return "Monday";
                    break;
                case 2:
                    return "Tuesday";
                    break;
                case 3:
                    return "Wednesday";
                    break;
                case 4:
                    return "Thursday";
                    break;
                case 5:
                    return "Friday";
                    break;
                case 6:
                    return "Saturday";
                    break;
                case 7:
                    return "Sunday";
                    break;
                default:
                    return null;
            }
        },
        toggleBusinessHours() {
            this.hoursEditData = JSON.parse(JSON.stringify(this.hoursShowData));
            if (
                this.hoursEditData["Saturday"].start == null &&
                this.hoursEditData["Saturday"].end == null
            ) {
                this.hoursEditData["Saturday"].closed = true;
            }
            if (
                this.hoursEditData["Sunday"].start == null &&
                this.hoursEditData["Sunday"].end == null
            ) {
                this.hoursEditData["Sunday"].closed = true;
            }
            this.editingHours = !this.editingHours;
        },
        updateBusinessHours(e) {
            if (e.val.A == "PM" && parseInt(e.val.hh) != 12) {
                this.hoursEditData[e.day][e.type] =
                    (parseInt(e.val.hh) + 12).toString() + e.val.mm;
            } else if(e.val.A == "AM" && parseInt(e.val.hh) == 12) {
                this.hoursEditData[e.day][e.type] = "00" + e.val.mm;
            } else {
                this.hoursEditData[e.day][e.type] = e.val.hh + e.val.mm;
            }
        },
        getScheduleItemUsage() {
            if (this.hoursType == "business") return 1;
        },
        async submitHours() {
            this.businessHoursArray = this.createArrayToEmit();
            await axios
                .post("/api/schedule/updateAll", {
                    schedule: [
                        ...this.businessHoursArray,
                        ...this.getPersonalHours(),
                    ],
                })
                .then((response) => {
                    this.hoursShowData = JSON.parse(
                        JSON.stringify(this.hoursEditData)
                    );
                    this.toggleBusinessHours();
                })
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        },
        getPersonalHours() {
            return this.user.schedule.filter((hoursDataItem) => {
                return hoursDataItem.usage == 0;
            });
        },
    },
    mounted() {
        this.user.schedule.forEach((hoursDataItem) => {
            if (hoursDataItem.usage == this.getScheduleItemUsage()) {
                this.hoursShowData[
                    this.getISOWeekDayName(hoursDataItem.day_of_week)
                ] = {
                    name: this.getISOWeekDayName(hoursDataItem.day_of_week),
                    start: hoursDataItem.start_time,
                    end: hoursDataItem.end_time,
                    closed: hoursDataItem.closed,
                };
            }
        });
    },
};
</script>
<style>
.vue__time-picker .dropdown ul, .vue__time-picker-dropdown ul{
    scrollbar-width: thin !important;
}
</style>
